const bankNumberLabel = {
  AU: "BSB",
  NZ: "",
};

export default bankNumberLabel;
